<!-- V DEV modu pro lepsi debug, si vlozim component ref-->
@if (isDevMode()) {
  <ng-content></ng-content>
}
